import React from 'react';
import { baseUrl } from '../baseUrl';
import { styled} from '@mui/material/styles';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import {Drawer, useTheme} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import MenuIcon from '@mui/icons-material/Menu';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
// import AppBars from './AppBars';
import { useState , useEffect} from 'react';
import axios from 'axios';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { useLocation } from 'react-router-dom';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
// import MyplayerLogo from '../images/MyPlayerLogo.png';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import CircularProgress from '@mui/material/CircularProgress';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditIcon from '@mui/icons-material/Edit';
import AddAlertOutlinedIcon from '@mui/icons-material/AddAlertOutlined';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
// import DatePicker from "react-datepicker";
import Menu from '@mui/material/Menu';
import EditNotificationsOutlinedIcon from '@mui/icons-material/EditNotificationsOutlined';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import Privacy from './Privacy';
// import { NavLink } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import MoreIcon from '@mui/icons-material/MoreVert';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';



const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme,open}) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
      }),
  }),
    backgroundColor: theme.palette.primary.main,
  }));
  
  const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(0),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 2,
        }),
    }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'center',
}));


  // const themeOptions = {
  //   palette: {
  //     type: 'light',
  //     primary: {
  //       main: 'rgb(255, 53, 3)',
  //     },
  //     secondary: {
  //       main: 'rgb(255, 255, 255)',
  //     },
  //   },
  // };

  const drawerWidth = 200;
  const sidebar_icon = [LeaderboardOutlinedIcon,HomeOutlinedIcon, NotificationAddOutlinedIcon, PersonOutlineOutlinedIcon, CategoryOutlinedIcon,EditNotificationsOutlinedIcon]
  
  export default function NotificationsConfig () {
    const location = useLocation();
    const { username } = location.state || '';
    const {loginStatus} = location.state || false;
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      if(loginStatus){
        onload();
      }
      else {
        navigate('/cms');
        // onload();
      }
    }, []);
    
    // const theme = createTheme(themeOptions);
    const theme = useTheme();
    const navigate = useNavigate();
    const [row, setRow] = useState([]);
    const [drawerOpen, setDraweropen] = useState(false);
    // const [user_id,setUser_id] =useState('');
    // const [open,setOpen] = useState(false);
    const [id,setId] = useState(false);
    const [title,setTitle] = useState('');
    const [body,setBody] = useState('');
    const [date,setDate] = useState('');
    const [category,setCategory] = useState('');

    const [AddTitle,setAddTitle] = useState('');
    const [AddBody,setAddBody] = useState('');
    const [AddDate,setAddDate] = useState('');
    const [AddCategory,setAddCategory] = useState('');

    const [deleteNotifications,setDelete] = useState(false);
    const [AddNotifications,setAdd] = useState(false);
    const [EditNotifications,setEdit] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [cleared, setCleared] = React.useState(false);

    const [WebanchorEl, setWebAnchorEl] = useState(null);
    const isMenuOpen = Boolean(WebanchorEl);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    useEffect(() => {
      if (cleared) {
        const timeout = setTimeout(() => {
          setCleared(false);
        }, 1500);
  
        return () => clearTimeout(timeout);
      }
      return () => {};
    }, [cleared]);


    const handleProfileMenuOpen = (event) => {
      setWebAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
      setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
      setWebAnchorEl(null);
      handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
      setMobileMoreAnchorEl(event.currentTarget);
    };


    const menuId = 'primary-search-account-menu';
    const renderMenu = (
      <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
          }}
          id={menuId}
          keepMounted
          transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
          }}
          open={isMenuOpen}
          onClose={handleMenuClose}
      >
          {/* <MenuItem onClick={handleLogout}>LogOut</MenuItem> */}
          {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
      </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
      <Menu
          anchorEl={mobileMoreAnchorEl}
          anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
          }}
          id={mobileMenuId}
          keepMounted
          transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
          }}
          open={isMobileMenuOpen}
          onClose={handleMobileMenuClose}
      >
          <MenuItem onClick={handleProfileMenuOpen}>
              <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="primary-search-account-menu"
                  aria-haspopup="true"
                  color="inherit"
              >
                  {/* <LogoutIcon /> */}
              </IconButton>
              <p>Profile</p>
          </MenuItem>
      </Menu>
    );


    const handleLogout = async () => {
      try {
          if (loginStatus) {
              navigate('/cms');
              // setLogoutStatus('Logout successful');
          } else {
              // setLogoutStatus('Logout unsuccessful');
              alert("Logout unsuccessful")
              window.location.reload(true)
          }
      } catch (error) {
          alert("An error occurred during logout")
          console.error('Error:', error);
          //   setLogoutStatus('An error occurred during logout');
      }
    }

    const handleDrawerToggle = () => {
    setDraweropen(!drawerOpen);
      };

    const onload = async() => {
        try{
          const result = await axios.get(`${baseUrl}inserted_notifications`)
          const datas = result.data.data.map((res,i)=> ({
            sq_no:i+1,
            id: res.id, 
            title:res.title, 
            body:res.body, 
            date: (res.date==null)? "--NA--" : res.date, 
            category:res.category}))
          setRow(datas)
          setLoading(false);
        }
        catch (error) {
          <Stack sx={{ width: '100%' }} spacing={2}>
              <Alert severity="error">
                  <AlertTitle>Error</AlertTitle>
                  Error occurred — <strong>check it out!</strong>
              </Alert>
          </Stack>
          setLoading(false);
      }
      }

    const CustomCellRenderer = ({ value }) => {
        return <div style={{ whiteSpace: 'pre-line',wordBreak: 'break-all'}}>{value}</div>;
      };

    const columns = [
        { field: 'sq_no', headerName: 'S.No', flex:0.20,sortable: false , headerClassName: 'custom-header',headerAlign: 'left',align: 'left'},
        // { field: 'id', headerName: 'ID', flex:1,sortable: false , headerClassName: 'custom-header',headerAlign: 'center',align: 'center'},
        { field: 'title', headerName: 'Title', flex: 0.7,sortable: false , headerClassName: 'custom-header',headerAlign: 'left',align: 'left',renderCell: CustomCellRenderer},
        { field: 'body', headerName: 'Body', flex: 2,sortable: false , headerClassName: 'custom-header',headerAlign: 'left',align: 'left',renderCell: CustomCellRenderer},
        { field: 'date', headerName: 'Date', flex: 0.3,sortable: false, headerClassName: 'custom-header',headerAlign: 'left',align: 'center' },
        { field: 'category', headerName: 'Category', flex: 0.3,sortable: false, headerClassName: 'custom-header',headerAlign: 'left',align: 'left' },
        { field: 'info', headerName:<InfoOutlinedIcon />,flex:0.1,sortable:false, headerClassName: 'custom-header',headerAlign: 'left',align: 'left',
        renderCell:(params)=>(
            <IconButton
            onClick={(event) => handleThreeDotClick(event,params.id,params.row.title,params.row.body,params.row.date,params.row.category)}
            color="primary"
            aria-label="Info"
            title="info"
            id="demo-positioned-button"
            aria-controls={open ? 'demo-positioned-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <MoreVertIcon color='action' />
          </IconButton>
        )
        }
    ]


    const handleThreeDotClick = (event,id,title,body,date,category) =>{
        // setOpen(true)
        console.log(date);
        setAnchorEl(event.currentTarget);
        setId(id)
        setTitle(title)
        setBody(body)
        setDate(date)
        setCategory(category)
      }

    const handleClose = () => {
        // setOpen(false);
        setAnchorEl(null);
      };

    const handleDelete = async() =>{
        setDelete(true);
      }

    const handleDeleteClose = async() =>{
        setDelete(false);
        setAnchorEl(null);
      }

    const handleDeleteOkay = async() =>{
        setDelete(false);
        // setOpen(false);
        setAnchorEl(null);
        try {
          console.log(id);
          const response = await axios.post(`${baseUrl}delete_notifications`, { "id":id});
          // console.log(response.data);
          const result = await response.data;
          if (result.status.code === 200) {
            window.location.reload(true);
          }
        }
        catch(e) {
          <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
      }

    const handleAdd = async() =>{
        setAdd(true);
      }

    const handleAddClose = async() => {
        setAdd(false);
        // setOpen(false);
        setAnchorEl(null);
      }

    const handleAddTitle = (event) =>{
        setAddTitle(event.target.value);
      }

    const handleAddBody = (event) =>{
        setAddBody(event.target.value);
      }

    const handleAddCategory = (event) =>{
        setAddCategory(event.target.value);
      }

    const handleAddDate = (date) => {
        // console.log(date);
        const formattedDate = dayjs(date).format("YYYY-MM-DD")
        // console.log(formattedDate);
        setAddDate(formattedDate);
      };

    const handleAddOkay = async() =>{
        setAdd(false);
        // setOpen(false);
        setAnchorEl(null);
        try {
          // console.log(id);
          const response = await axios.post(`${baseUrl}add_notifications`, { "title":AddTitle,"body":AddBody,"date":AddDate,"category":AddCategory});
          // console.log(response.data);(AddDate === '') ? "null" : AddDate
          const result = await response.data;
          if (result.status.code === 200) {
            window.location.reload(true);
          }
        }
        catch(e) {
          <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
      }

    const handleEdit = async() =>{
        setEdit(true);
      }

    const handleEditClose = async() =>{
        setEdit(false);
        // setOpen(false);
        setAnchorEl(null);
      }

    const handleEditTitle = async(event) =>{
        setTitle(event.target.value);
      }

    const handleEditBody = async(event) =>{
        setBody(event.target.value);
      }

    const handleEditCategory = async(event) =>{
        setCategory(event.target.value);
      }

    const handleEditDate = async(date) =>{
        const formattedDate = dayjs(date).format("YYYY-MM-DD")
        setDate(formattedDate);
      }

    const handleEditOkay = async() =>{
        setEdit(false);
        // setOpen(false);
        setAnchorEl(null);
        try {
          // console.log(id);
          const response = await axios.post(`${baseUrl}edit_notifications`, { "id":id,"title":title,"body":body,"date":(date === '--NA--') ? '' :date,"category":category});
          const result = await response.data;
          if (result.status.code === 200) {
            window.location.reload(true);
          }
        }
        catch(e) {
          // <Stack sx={{ width: '100%' }} spacing={2}>   (AddDate === '') ? "null" : AddDate
          //       <Alert severity="error">
          //           <AlertTitle>Error</AlertTitle>
          //           Error occurred — <strong>check it out!</strong>
          //       </Alert>
          //   </Stack>
          alert("Error Occured While updating Notifications.")
        }
      }

    const category_list = ['Daily','Occassions','Reminder']

    return (
        <>
        {/* <ThemeProvider theme={theme}> */}
                    {/* <Dialog open={open} onClose={handleClose} style={dialogStyle}> */}
          <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              // anchorOrigin={{
              //   vertical: 'top',
              //   horizontal: 'left',
              // }}
              // transformOrigin={{
              //   vertical: 'top',
              //   horizontal: 'left',
              // }}
          >
              {/* <DialogActions sx={{display:'flex',flexDirection:'column',
              '& > *': {
                  m:1,
                  },
                  }}> */}
                  {/* <MenuItem> */}
                  {/* <MenuItem  title="Add" onClick={handleAdd}> <AddAlertOutlinedIcon /> </MenuItem > style={{'color': theme.palette.primary.main}} */}
                  <MenuItem  title="Edit" onClick={handleEdit} > <EditIcon /> </MenuItem >
                  <MenuItem  title="Delete" onClick={handleDelete} > <DeleteForeverOutlinedIcon /></MenuItem >
              {/* </DialogActions> */}
                  {/* </MenuItem> */}
          {/* </Dialog> */}
          </Menu>

          <Dialog open={deleteNotifications} onClose={handleDeleteClose}>
              <DialogTitle>Delete Notification</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Are you sure you want to delete this Notification?
                  </DialogContentText>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleDeleteClose} >Cancel</Button>
                  <Button onClick={handleDeleteOkay} >Okay</Button>
              </DialogActions>
          </Dialog>

          <Dialog open={AddNotifications} onClose={handleAddClose}>
            <DialogTitle>ADD Notification</DialogTitle>
            <DialogContent>
              <TextField id="title" label="TITLE" variant="standard" fullWidth value={AddTitle} onChange={handleAddTitle} required/>
              <TextField id="standard-basic" label="BODY" variant="standard" fullWidth value={AddBody} onChange={handleAddBody} required />
              {/* <TextField {...category_list} category="standard-basic" label="CATEGORY" variant="standard" fullWidth value={AddCategory} onChange={handleAddCategory}/> */}

              <FormControl fullWidth variant="standard" style={{marginBottom:20}}>
                <InputLabel>CATEGORY</InputLabel>
                <Select
                  label="CATEGORY"
                  value={AddCategory}
                  onChange={handleAddCategory}
                  required
                >
                  {category_list.map((category, index) => (
                    <MenuItem key={index} value={category}>
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* <TextField id="standard-basic" label="Date" variant="standard" fullWidth value={AddDate} /> */}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DateCalendar
                  // value={expireddate}
                  onChange={(date) => { handleAddDate(`${date}`) }}
                  renderInput={(params) => <TextField {...params} label="Date" variant="standard" fullWidth
                    value={date}
                  // format="YYYY-MM-DD"
                  />}
                /> */}

              <DesktopDatePicker format="DD/MM/YYYY" label="Date" onChange={(date) => { handleAddDate(`${date}`) }}
                slotProps={{
                  textField: {
                    helperText: 'DD/MM/YYYY',
                  },
                }}
              />
              </LocalizationProvider>
            
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAddClose}>CANCEL</Button>
              <Button onClick={handleAddOkay}>ADD</Button>
            </DialogActions>
          </Dialog>
                  
          <Dialog open={EditNotifications} onClose={handleEditClose}>
              <DialogTitle>EDIT Notification</DialogTitle>
              <DialogContent>
                <TextField id="standard-basic" label="TITLE" variant="standard" fullWidth value={title} onChange={handleEditTitle} style={{marginBottom:15}}/>
                <TextField id="standard-basic" label="BODY" variant="standard" fullWidth value={body} onChange={handleEditBody} style={{marginBottom:15}}/>
                {/* <TextField {...category_list} category="standard-basic" label="CATEGORY" variant="standard" fullWidth value={AddCategory} onChange={handleAddCategory}/> */}

                <FormControl fullWidth variant="standard" style={{marginBottom:15}}>
                  <InputLabel>CATEGORY</InputLabel>
                  <Select
                    label="CATEGORY"
                    value={category}
                    onChange={handleEditCategory}
                  >
                    {category_list.map((category, index) => (
                      <MenuItem key={index} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* <TextField id="standard-basic" label="Date" variant="standard" fullWidth value={date} /> */}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* <DateCalendar
                    onChange={(date) => { handleEditDate(`${date}`) }}
                    renderInput={(params) => <TextField {...params} label="Date" variant="standard" fullWidth
                    value={date}
                  />}
                  /> */}

                  <DesktopDatePicker label="Date" format="DD/MM/YYYY" defaultValue={dayjs(date)} onChange={(date) => { handleEditDate(`${date}`) }}
                    slotProps={{
                      textField: {
                        helperText: 'DD/MM/YYYY',
                      },
                      // field: { clearable: true, onClear: () => setCleared(true) }
                      // actionBar: {
                      //   actions: ['clear']
                      // }
                    }}
                  /> 
                    {cleared && (
                      <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                      >
                        Field cleared!
                      </Alert>
                    )}
                </LocalizationProvider>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleEditClose}>CANCEL</Button>
                <Button onClick={handleEditOkay}>EDIT</Button>
              </DialogActions>
          </Dialog>

          <Box sx={{ flexGrow: 1 }}>
              <CssBaseline />
              <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={drawerOpen}>
                  <Toolbar>
                  <IconButton
                          color="inherit"
                          aria-label="open drawer"
                          onClick={handleDrawerToggle}
                          edge="start"
                          sx={{ mr: 0, ...(open && { display: 'none' }) }}
                      >
                          <MenuIcon />
                      </IconButton>
                      <Typography variant="h6" noWrap component="div"  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                          YaYa Player
                      </Typography>
                      <Box sx={{ flexGrow: 1 }} />
                      <Button title="Add Notifications" onClick={handleAdd} size='medium' variant="outlined" style={{backgroundColor: theme.palette.background.default }}><AddAlertOutlinedIcon  />Add Push NotiFications</Button>

                    <Box sx={{ display: { xs: 'none', md: 'flex'} }}>
                      <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={menuId}
                        aria-haspopup="true"
                        onClick={handleProfileMenuOpen}
                        color="inherit"
                    >
                        <LogoutIcon />
                      </IconButton> 
                    </Box>

                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                      <IconButton
                          size="large"
                          aria-label="show more"
                          aria-controls={mobileMenuId}
                          aria-haspopup="true"
                          onClick={handleMobileMenuOpen}
                          color="inherit"
                      >
                      <MoreIcon />
                    </IconButton>
                    </Box>

                      {/* <img style={{ width: '50px', height: '50px', marginRight: '2px' }} src={MyplayerLogo} alt='logo' />
                      <Typography variant="h6" noWrap component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',marginRight: 'auto' }}>
                          MyPlayer
                      </Typography>
                      <Button title="Add Notifications" onClick={handleAdd} size='large' variant="outlined" style={{backgroundColor: theme.palette.background.default }}><AddAlertOutlinedIcon  />Add Push NotiFications</Button> */}
                  </Toolbar>
              </AppBar>
              {renderMobileMenu}
              {renderMenu}

              <Drawer
                  variant="persistent"
                  anchor="left"
                  open={drawerOpen}
                  sx={{
                      width: drawerWidth,
                      flexShrink: 0,
                      '& .MuiDrawer-paper': {
                          width: drawerWidth,
                          boxSizing: 'border-box',
                      },
                  }}
              >
                <DrawerHeader>
                      <img style={{width:'50px',height:'50px',marginRight: '1px'}} src={"https://beeitech.com/images/logo/appicon.png"} alt='logo'/>
                </DrawerHeader>
                  <Divider />
                  <List>

                      <ListItem key="Dashboard" disablePadding>
                          <ListItemButton component={Link} to="/cms/dashboard" state={{ username: username,loginStatus:loginStatus }}>
                              <ListItemIcon>
                                  {React.createElement(sidebar_icon[0])}
                              </ListItemIcon>
                              <ListItemText primary="Dashboard" />
                          </ListItemButton>
                      </ListItem>

                      <ListItem key="Home" disablePadding>
                          <ListItemButton component={Link} to="/cms/homescreen" state={{ username: username,loginStatus:loginStatus }}>
                          {/* <ListItemButton  > */}
                          {/* <NavLink to='/homescreen' activeClassName="active" state={{ username: username,loginStatus:loginStatus }}> */}
                              <ListItemIcon>
                                  {React.createElement(sidebar_icon[1])}
                              </ListItemIcon>
                              <ListItemText primary="Home Screen" />
                          {/* </NavLink> */}
                          </ListItemButton>
                      </ListItem>

                      {/* <ListItem key="Send Notification" disablePadding>
                          <ListItemButton component={Link} to="/cms/sendnotifications" state={{ username: username,loginStatus:loginStatus }}>
                              <ListItemIcon>
                                  {React.createElement(sidebar_icon[2])}
                              </ListItemIcon>
                              <ListItemText primary="Send Notification" />
                          </ListItemButton>
                      </ListItem> */}

                      <ListItem key="Users" disablePadding>
                          <ListItemButton component={Link} to="/cms/userpage" state={{ username: username,loginStatus:loginStatus }}>
                              <ListItemIcon>
                                  {React.createElement(sidebar_icon[3])}
                              </ListItemIcon>
                              <ListItemText primary="Users" />
                          </ListItemButton>
                      </ListItem>

                      {/* <ListItem key="Category" disablePadding>
                          <ListItemButton onClick={handleCategory}>
                              <ListItemIcon>
                                  {React.createElement(sidebar_icon[4])}
                              </ListItemIcon>
                              <ListItemText primary="Add Category" />
                          </ListItemButton>
                      </ListItem> */}

                      <ListItem class="drawer-select" key ="Notifications Config" disablePadding>
                          <ListItemButton onClick={() => window.location.reload(true)}>
                              <ListItemIcon>
                                  {React.createElement(sidebar_icon[5])}
                              </ListItemIcon>
                              <ListItemText primary="Notifications Config" />
                          </ListItemButton>
                      </ListItem>

                  </List>
                  <Divider />
                  <Privacy />
              </Drawer>


              <div>
                  {loading ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                          <CircularProgress style={{ 'color': '#ff3300e1' }} />
                      </Box>
                  ) : (
                    <Main open={drawerOpen}>
                    <DrawerHeader />
                    <Box sx={{ marginLeft: '200px', display: 'flex', flexDirection: 'column'}}>
                      <DataGrid
                          autoHeight
                          rowHeight={80}
                          rows={row}
                          columns={columns}
                          initialState={{
                            pagination: {
                              paginationModel: { page: 0, pageSize: 10 },
                            },
                          }}
                          getRowClassName={(params) =>
                              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                          }
                          // sx={{ marginTop: 8 }}
                      />
                      </Box>
                      </Main>
                  )}
                  {/* checkboxSelection */}

              </div>
              {/* </Main> */}
          </Box>
            {/* </ThemeProvider> */}
        </>
    )
}
